import { SystemDescriptions } from "src/common/descriptions";
import { SidebarDescriptions } from "src/common/descriptions/components/Sidebar/types";
import { UserRoles } from "src/common/models/user";
import { Urls } from "src/common/urls";

interface MenuOptionChildren {
    path: string
    id: string
    displayName: string
}

export interface MenuOption {
    id: string;
    displayName: string;
    path: string;
    icon: string;
    iconSelected: string;
    children: MenuOptionChildren[]
    roles?: UserRoles[]
}

export interface MenuSection {
    id: string;
    displayName: string;
    icon: string;
    iconSelected: string;
    items: MenuOption[]
    path?: string
    roles: UserRoles[]
}

const MenuDescriptions: SidebarDescriptions = SystemDescriptions.COMPONENTS.SIDEBAR

export const MenuSections: MenuSection[] = [
    {
        id: '0',
        displayName: MenuDescriptions.HOME.TITLE,
        icon: 'fas fa-home',
        iconSelected: '',
        roles: [UserRoles.ALL],
        items: [],
        path: Urls.FRONTEND.HOME,
    },
    {
        id: 'CHAT',
        displayName: MenuDescriptions.CHAT.TITLE,
        icon: 'fas fa-comment-dots',
        iconSelected: '',
        roles: [UserRoles.ALL],
        items: [],
        path: Urls.FRONTEND.CHAT,
    },
    {
        id: 'FINANCE',
        displayName: MenuDescriptions.FINANCE.TITLE,
        icon: 'fas fa-window-maximize',
        iconSelected: '',
        roles: [UserRoles.ALL],
        items: [
            {
                path: Urls.FRONTEND.SERVICE_CONTRACT_DEBIT.SERVICE_CONTRAC_DEBITS,
                id: Urls.FRONTEND.SERVICE_CONTRACT_DEBIT.SERVICE_CONTRAC_DEBITS,
                displayName: MenuDescriptions.FINANCE.ITEMS.ACCOUNT_RECEIVABLES.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT.PAYABLE_CONTRACT_DEBITS,
                id: Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT.PAYABLE_CONTRACT_DEBITS,
                displayName: MenuDescriptions.FINANCE.ITEMS.ACCOUNT_PAYABLES.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.EXPENDITURE_RECORD.RECORDS,
                id: Urls.FRONTEND.EXPENDITURE_RECORD.RECORDS,
                displayName: MenuDescriptions.FINANCE.ITEMS.EXPENDITURE_RECORDS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.EXPENDITURE_RECORD.CREATE,
                id: Urls.FRONTEND.EXPENDITURE_RECORD.CREATE,
                displayName: MenuDescriptions.FINANCE.ITEMS.CREATE_EXPENDITURE_RECORD.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.INCOME_RECORD.RECORDS,
                id: Urls.FRONTEND.INCOME_RECORD.RECORDS,
                displayName: MenuDescriptions.FINANCE.ITEMS.INCOME_RECORDS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.INCOME_RECORD.CREATE,
                id: Urls.FRONTEND.INCOME_RECORD.CREATE,
                displayName: MenuDescriptions.FINANCE.ITEMS.CREAT_INCOME_RECORD.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
        ],
    },
    {
        id: 'CUSTOMER',
        displayName: MenuDescriptions.CUSTOMER.TITLE,
        icon: 'fas fa-window-maximize',
        iconSelected: '',
        roles: [UserRoles.ALL],
        items: [
            {
                path: Urls.FRONTEND.SERVICE_CONTRACT.CREATE,
                id: Urls.FRONTEND.SERVICE_CONTRACT.CREATE,
                displayName: MenuDescriptions.CUSTOMER.ITEMS.CREATE_SERVICE_CONTRACT.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.CUSTOMER.CUSTOMERS,
                id: Urls.FRONTEND.CUSTOMER.CUSTOMERS,
                displayName: MenuDescriptions.CUSTOMER.ITEMS.CUSTOMERS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.SERVICE_CONTRACT.SERVICE_CONTRACTS,
                id: Urls.FRONTEND.SERVICE_CONTRACT.SERVICE_CONTRACTS,
                displayName: MenuDescriptions.CUSTOMER.ITEMS.SERVICE_CONTRACTS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.SERVICE_CONTRACT_DEBIT_PAYMENTS.SERVICE_CONTRAC_DEBITS,
                id: Urls.FRONTEND.SERVICE_CONTRACT_DEBIT_PAYMENTS.SERVICE_CONTRAC_DEBITS,
                displayName: MenuDescriptions.CUSTOMER.ITEMS.SERVICE_CONTRACT_PAYMENTS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
        ],
    },
    {
        id: 'SUPPLIER',
        displayName: MenuDescriptions.SUPPLIER.TITLE,
        icon: 'fas fa-window-maximize',
        iconSelected: '',
        roles: [UserRoles.ALL],
        items: [
            {
                path: Urls.FRONTEND.ACCOUNT_PAYABLE.CREATE,
                id: Urls.FRONTEND.ACCOUNT_PAYABLE.CREATE,
                displayName: MenuDescriptions.SUPPLIER.ITEMS.CREATE_PAYABLE_CONTRACT.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.ACCOUNT_PAYABLE.PAYABLE_CONTRACTS,
                id: Urls.FRONTEND.ACCOUNT_PAYABLE.PAYABLE_CONTRACTS,
                displayName: MenuDescriptions.SUPPLIER.ITEMS.PAYABLE_CONTRACTS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT_PAYMENTS.PAYABLE_CONTRACT_PAYMENTS,
                id: Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT_PAYMENTS.PAYABLE_CONTRACT_PAYMENTS,
                displayName: MenuDescriptions.SUPPLIER.ITEMS.PAYABLE_CONTRACT_PAYMENTS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
        ],
    },
    {
        id: 'QUOTATION',
        displayName: MenuDescriptions.QUOTATION.TITLE,
        icon: 'fas fa-window-maximize',
        iconSelected: '',
        roles: [UserRoles.ALL],
        items: [
            {
                path: Urls.FRONTEND.QUOTATION.CREATE,
                id: Urls.FRONTEND.QUOTATION.CREATE,
                displayName: MenuDescriptions.QUOTATION.ITEMS.CREATE_QUOTATION.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.QUOTATION.RECORDS,
                id: Urls.FRONTEND.QUOTATION.RECORDS,
                displayName: MenuDescriptions.QUOTATION.ITEMS.QUOTATION_RECORDS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.QUOTATION.TEMPLATES,
                id: Urls.FRONTEND.QUOTATION.TEMPLATES,
                displayName: MenuDescriptions.QUOTATION.ITEMS.QUOTATION_TEMPLATES.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
        ],
    },
    {
        id: 'REPORT',
        displayName: MenuDescriptions.REPORTS.TITLE,
        icon: 'fas fa-window-maximize',
        iconSelected: '',
        roles: [UserRoles.ADMIN],
        items: [
            {
                path: Urls.FRONTEND.CASHBOX_STATEMENT.RECORDS,
                id: Urls.FRONTEND.CASHBOX_STATEMENT.RECORDS,
                displayName: MenuDescriptions.REPORTS.ITEMS.CASHBOX_STATEMENT_RECORDS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.DASHBOARD,
                id: Urls.FRONTEND.DASHBOARD,
                displayName: MenuDescriptions.REPORTS.ITEMS.DASHBOARD.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
        ],
    },
    {
        id: 'MAINTAINANCE',
        displayName: MenuDescriptions.MAINTENANCE.TITLE,
        icon: 'fas fa-cog',
        iconSelected: '',
        roles: [UserRoles.ADMIN],
        items: [
            {
                path: Urls.FRONTEND.SERVICE.SERVICES,
                id: Urls.FRONTEND.SERVICE.SERVICES,
                displayName: MenuDescriptions.MAINTENANCE.ITEMS.SERVICES.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.SERVICE_CATEGORY.SERVICE_CATEGORIES,
                id: Urls.FRONTEND.SERVICE_CATEGORY.SERVICE_CATEGORIES,
                displayName: MenuDescriptions.MAINTENANCE.ITEMS.SERVICE_CATEGORIES.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.CASHBOX_CATEGORY.RECORDS,
                id: Urls.FRONTEND.CASHBOX_CATEGORY.RECORDS,
                displayName: MenuDescriptions.MAINTENANCE.ITEMS.CASHBOX_CATEGORIES.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.USER.USERS,
                id: Urls.FRONTEND.USER.USERS,
                displayName: MenuDescriptions.MAINTENANCE.ITEMS.USERS.DISPLAY_NAME,
                icon: "fas fa-window-restore",
                iconSelected: "",
                children: [],
            },
            {
                path: Urls.FRONTEND.SETTINGS,
                id: Urls.FRONTEND.SETTINGS,
                displayName: MenuDescriptions.MAINTENANCE.ITEMS.SETTINGS.DISPLAY_NAME,
                icon: "fas fa-cog",
                iconSelected: "",
                children: [],
            },
        ],
    },
]
